module.exports = __webpack_public_path__ + "static/media/av-help.4a1a7fac.png";